import React from "react";

import StatusListItem from "../../components/Status/StatusListItem";
import ChatTailwickListSkeleton from "./ChatTailwickListSkeleton";
import { i18n } from "../../translate/i18n";

function StatusEmptyState() {
	return (
		<div className="flex flex-col items-center justify-center px-5 py-16 text-center">
			<div className="mb-4 flex size-14 items-center justify-center rounded-full bg-default-150 text-primary">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="26"
					height="26"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
					aria-hidden
				>
					<circle cx="12" cy="12" r="10" />
					<circle cx="12" cy="12" r="3" />
				</svg>
			</div>
			<h6 className="card-title mb-1 text-sm">{i18n.t("statusList.emptyTitle")}</h6>
			<p className="max-w-[16rem] text-xs leading-relaxed text-default-500">
				{i18n.t("statusList.emptyMessage")}
			</p>
		</div>
	);
}

export default function TailwickStatusListView({
	tickets,
	loading,
	final,
	loadMore,
	onScroll,
}) {
	const isEmpty = tickets.length === 0 && !loading;

	return (
		<div className="tailwick-chats-scroll flex min-h-0 flex-1 flex-col overflow-hidden">
			<div className="shrink-0 border-b border-default-200 px-5 py-3">
				<h6 className="text-sm font-semibold text-default-800">
					{i18n.t("statusList.title")}
				</h6>
				<p className="mt-0.5 text-xs text-default-500">
					{i18n.t("statusList.subtitle")}
				</p>
			</div>

			<div
				className="tailwick-status-list min-h-0 flex-1 overflow-y-auto"
				onScroll={onScroll}
			>
				{isEmpty ? (
					<StatusEmptyState />
				) : (
					tickets.map((ticket) => (
						<StatusListItem
							key={ticket.id}
							ticket={ticket}
							relatedTickets={ticket.relatedTickets}
						/>
					))
				)}
				{loading && <ChatTailwickListSkeleton />}
			</div>

			{final && !isEmpty && (
				<div className="shrink-0 border-t border-default-200 px-4 py-3">
					<button
						type="button"
						className="btn w-full bg-default-150 text-sm text-default-600 hover:bg-default-200 disabled:opacity-70"
						onClick={loadMore}
						disabled={loading}
					>
						{loading ? i18n.t("chat.layout.loadingMore") : i18n.t("chat.layout.loadMore")}
					</button>
				</div>
			)}
		</div>
	);
}
